<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings">
            <th
              v-for="head in HEAD"
              @click="filterByTitle(head.name)"
              :key="head.title"
              :width="head.width"
              :class="{ headHover: head.name }"
              class="column-title"
            >
              {{ head.title }}
            </th>
            <th class="column-title no-link last">
              <span class="nobr">檢視</span>
            </th>
            <th class="bulk-actions" colspan="7">
              <a class="antoo">
                Bulk Actions (
                <span class="action-cnt"></span>
                )
                <i class="fa fa-chevron-down"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(driver, index) in filter_list">
            <tr
              v-if="filter_list.length > 0"
              :class="{
                even: index % 2 == 0,
                odd: index % 2 != 0,
              }"
              class="pointer"
              :key="driver.id"
            >
              <td>{{ driver.call_number }}</td>
              <td>{{ driver.name }}</td>
              <td>{{ driver.group }}</td>
              <td>{{ driver.phone }}</td>
              <td>{{ driver.licence }}</td>
              <td>{{ driver.note || '' }}</td>
              <td>{{ driver.reputation }}</td>
              <td class="a-right">{{ driver.authorize }}</td>
              <td class="last">
                <router-link
                  class="red_textcolor"
                  :to="{
                    name: 'driverDetail',
                    params: { id: driver.id },
                  }"
                >
                  檢視
                </router-link>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </el-col>
  </el-row>
</template>

<script>
import { driver } from '@/constants/tableHead'

export default {
  props: {
    filter_list: Array,
  },
  methods: {
    filterByTitle(name) {
      if (name) {
        this.$emit('onTitle', name)
      }
    },
  },
  created() {
    this.HEAD = driver
  },
}
</script>

<style scoped>
.headHover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/components/SealTable.vue